<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 800px; max-width: 90vw;">
      <q-card-section>
        <div class="text-h6">
          <q-icon name="hub" color="purple" class="q-mr-sm" />
          Assemble Compound {{ formData.item_type === 'device' ? 'Device' : 'Equipment' }}
        </div>
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="$emit('submit')">
          <div class="q-mb-md">
            <q-input
              :model-value="formData.name"
              :label="`Compound ${formData.item_type === 'device' ? 'Device' : 'Equipment'} Name`"
              outlined
              :rules="[val => !!val || 'Name is required']"
              hint="E.g., CHWV-101 Assembly"
              @update:model-value="$emit('update:name', $event)"
            />
          </div>

          <div class="q-mb-md">
            <q-input
              :model-value="formData.description"
              label="Description"
              outlined
              type="textarea"
              rows="2"
              @update:model-value="$emit('update:description', $event)"
            />
          </div>

          <div class="q-mb-md">
            <q-select
              :model-value="formData.brick_class"
              :options="brickClassOptions"
              label="BRICK Class"
              outlined
              emit-value
              map-options
              :rules="[val => !!val || 'BRICK class is required']"
              @update:model-value="$emit('update:brick-class', $event)"
            />
          </div>

          <div class="q-mb-md">
            <q-select
              :model-value="formData.parent_role"
              :options="parentRoleOptions"
              label="Primary Equipment Role"
              outlined
              emit-value
              map-options
              hint="Which equipment will be the primary/controller?"
              @update:model-value="$emit('update:parent-role', $event)"
            />
          </div>

          <!-- Selected Components -->
          <q-card flat bordered class="q-mb-md">
            <q-card-section>
              <div class="text-subtitle2 q-mb-sm">Components to Assemble:</div>
              <q-list dense separator>
                <q-item v-for="item in selectedItems" :key="item.id">
                  <q-item-section avatar>
                    <q-icon :name="item.icon || 'precision_manufacturing'" />
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ item.label || item.name }}</q-item-label>
                    <q-item-label caption>{{ item.brickClass || item.brick_class }}</q-item-label>
                  </q-item-section>
                  <q-item-section side>
                    <q-select
                      :model-value="item.relationship"
                      :options="relationshipOptions"
                      dense
                      outlined
                      emit-value
                      map-options
                      style="min-width: 150px"
                      @update:model-value="$emit('update:relationship', item.id, $event)"
                    />
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
          </q-card>

          <q-card flat bordered class="bg-warning-1 q-pa-sm">
            <div class="text-caption">
              <q-icon name="info" color="warning" />
              Components will be assembled into a single compound equipment entity.
              Individual components will become sub-equipment of the compound.
            </div>
          </q-card>
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('cancel')" />
        <q-btn
          color="purple"
          label="Assemble"
          icon="hub"
          :loading="saving"
          @click="$emit('submit')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: true },
    formData: { type: Object, required: true },
    selectedItems: { type: Array, required: true },
    brickClassOptions: { type: Array, required: true },
    parentRoleOptions: { type: Array, required: true },
    relationshipOptions: { type: Array, required: true },
    saving: { type: Boolean, default: false },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:description',
    'update:brick-class',
    'update:parent-role',
    'update:relationship',
    'submit',
    'cancel',
  ]);
</script>
